import React from "react";
import "./GiveNps.scss";
import { envConfig } from "../../../config/config";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState } from "react";
import { useEffect } from "react";
import { getPublicStore, updateNpsComment } from "../../../api/storeApi";
import { createUser } from "../../../api/userApi";
import { savePrivateReview } from "../../../api/feedbackApi";
import Loading from "../../../commons/components/utils/Loading";
import translate from "../../../config/translations/translate";
import { translations } from "../../../config/translations/Feedback/GiveNps";
import { MDBBtn, MDBIcon } from "mdbreact";

import "./NpsInOneStep.scss";

const MySwal = withReactContent(Swal);

const GiveNps = ({ t }) => {
  const [store, setStore] = useState();
  const [userRegistered, setUserRegistered] = useState();
  const [userIdFromRegister, setUserIdFromRegister] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [comment, setComment] = useState();
  const [score, setScore] = useState();
  const [showReviewForm, setShowReviewForm] = useState();
  const history = useHistory();
  const [commentPosted, setCommentPosted] = useState(false);

  const params = new URLSearchParams(history.location.search);
  const storeId = params.get("storeId");
  const userId = params.get("userId");
  const deliveryId = params.get("deliveryId");
  const utmSource = params.get("utm_source");
  const utmMedium = params.get("utm_medium");
  const utmCampaign = params.get("utm_campaign");
  const variant = params.get("variant");
  const name = params.get("name") ? params.get("name") : "";
  const phone = params.get("phone");
  const correlationId = params.get("correlationId");
  const gating = params.get("g");
  const scoreParam = params.get("score");
  const redirectTo = params.get("redirectTo");

  useEffect(async () => {
    const response = await getPublicStore(storeId);
    const selectedStore = response.data.data;
    const storeHasGoogleOrFacebookConfigured =
      selectedStore.googleBusinessURL || selectedStore.facebookURL;
    setStore(selectedStore);
    if (!userId) {
      registerUser();
    } else {
      setUserRegistered(true);
      // if (correlationId) trackEvent("REVIEW_REQUEST_SHOWED", { correlationId: correlationId }, false, [trackers.BACKEND_UNSECURE])
    }

    if (redirectTo) {
      const redirection = selectedStore[redirectTo];
      if (redirection) {
        window.location.href = redirection;
      } else {
        setShowReviewForm(true);
      }
    } else {
      setShowReviewForm(!storeHasGoogleOrFacebookConfigured);
    }

    if (scoreParam) {
      const n = parseInt(scoreParam);
      setShowReviewForm(true);
      handleNps(n);
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleNps = (n) => {
    const emailUniqueId = params.get("emailUniqueId")
      ? params.get("emailUniqueId")
      : storeId + getUserId() + Date.now();
    const storeIdParam = `storeId=${storeId}`;
    const userIdParam = `&userId=${getUserId()}`;
    const scoreIdParam = `&score=${n}`;
    const emailUniqueIdParam = `&emailUniqueId=${emailUniqueId}`;
    const deliveryIdParam = deliveryId ? `&deliveryId=${deliveryId}` : "";
    const utmSourceParam = utmSource ? `&utm_source=${utmSource}` : "";
    const utmMediumParam = utmMedium ? `&utm_medium=${utmMedium}` : "";
    const utmCampaignParam = utmCampaign ? `&utm_campaign=${utmCampaign}` : "";
    const variantParam = variant ? `&variant=${variant}` : "";
    const correlationIdParam = correlationId
      ? `&correlationId=${correlationId}`
      : "";

    if (gating === "true") {
      window.location.href = `${envConfig.frontendPhpUrl}/npsFeedback.php?${storeIdParam}${userIdParam}${emailUniqueIdParam}${scoreIdParam}${deliveryIdParam}${utmSourceParam}${utmMediumParam}${utmCampaignParam}${variantParam}${correlationIdParam}`;
    } else {
      const npsBody = {
        storeId: params.get("storeId"),
        userId: params.get("userId"),
        deliveryId: params.get("deliveryId"),
        utmSource: params.get("utm_source"),
        utmMedium: params.get("utm_medium"),
        utmCampaign: params.get("utm_campaign"),
        variant: params.get("variant"),
        name: params.get("name"),
        phone: params.get("phone"),
        correlationId: params.get("correlationId"),
        g: params.get("g"),
        emailUniqueId: emailUniqueId,
        score: n,
      };

      savePrivateReview(npsBody).then(() => {
        setScore(n);
        setIsLoading(false);
      });
    }
  };

  const npsButton = (number) => {
    return (
      <a
        key={"key-nps-button-" + number}
        class="star"
        href="#selectOption"
        onClick={() => handleNps(number)}
      >
        {" "}
      </a>
    );
  };

  const registerUser = () => {
    const userObj = {
      name: name,
      phone: phone,
    };
    const externalParams = {
      registeredThrough: "REVIEW_REQUEST",
      source: "BOTBIT",
    };
    const config = {
      headers: {
        Authorization: `Bearer ${envConfig.token}`,
      },
    };
    createUser(userObj, storeId, externalParams, config).then((res) => {
      if (res.status === 200) {
        setUserRegistered(true);
        const userId = res.data.data.id;
        setUserIdFromRegister(userId);
        /*
            if (correlationId) {
                trackEvent(
                    "REVIEW_REQUEST_SHOWED",
                    { correlationId: correlationId },
                    false,
                    [trackers.BACKEND_UNSECURE]
                );
            }
            */
      }
    });
  };

  const getUserId = () => {
    if (userId) return userId;
    else if (userIdFromRegister) return userIdFromRegister;
  };
  const getQuestion = () => {
    return store.customNpsQuestion ? (
      store.customNpsQuestion
        .replace("{tienda}", store.name)
        .replace("{nombre}", name)
        .replace("{Nombre}", name)
    ) : (
      <>
        {t("howProbably.first")} <strong>{store.name}</strong>{" "}
        {t("howProbably.second")}
      </>
    );
  };
  // no quiero que aparezcan las graficas si voy a redirigir
  if (redirectTo === "googleBusinessURL" || redirectTo === "facebookURL")
    return null;

  if (!storeId || (!userId && !phone)) {
    MySwal.fire({
      type: "error",
      title: "Oops...",
      text: "Lo sentimos, no pudimos acceder",
    });
    return {};
  } else {
    return (
      <div id="give-nps">
        {store && <Header {...{ store, t }}></Header>}
        {
          // Formulario de review
          store && !showReviewForm && (
            <div className="nps-source-options">
              <Content {...{ store, t, setShowReviewForm }} />
            </div>
          )
        }
        {store &&
          userRegistered &&
          !isLoading &&
          showReviewForm &&
          !commentPosted && (
            <div className="main-content">
              {score === undefined && (
                <>
                  <div className="nps-body">
                    <h2>{getQuestion()}</h2>
                  </div>
                  <div className="give-nps-buttons">
                    <div className="text-center w-100">
                      <div className="container">
                        {[2, 4, 6, 8, 10].map((n) => npsButton(n))}
                      </div>
                      <div>
                        <span className="mr-4">{t("unlikely")} </span>
                        <span className="ml-5">{t("veryLikely")}</span>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {score !== undefined && (
                <div>
                  <div className="my-4">
                    <textarea
                      className="private-comment-input"
                      placeholder={t("privateComment")}
                      id="private-comment-input"
                      type="textarea"
                      outline
                      value={comment}
                      onChange={(e) => {
                        setComment(e.target.value);
                      }}
                    />
                  </div>
                  <MDBBtn
                    color="custom"
                    disabled={!!!comment}
                    className="private-send review-btn text-center"
                    onClick={() => {
                      if (comment) {
                        setIsLoading(true);
                        const body = {
                          comment,
                          correlationId,
                        };
                        updateNpsComment(body).then(() => {
                          setIsLoading(false);
                          setCommentPosted(true);
                        });
                      }
                    }}
                  >
                    <MDBIcon className="mr-1" icon="paper-plane" />{" "}
                    {t("sendComment")}
                  </MDBBtn>
                </div>
              )}
            </div>
          )}
        {
          // Mensaje de gracias al dejar el comentario
          commentPosted && (
            <div className="nps-body">
              <h2>
                {t("thankForComment")}
                <br />
                <br />
                {t("canClose")}
              </h2>
            </div>
          )
        }
        {(!store || isLoading) && <Loading loading={true} />}
        <div className="powered-by">
          <span>Powered by</span>{" "}
          <img
            alt="botbit-log"
            src={`${envConfig.staticImgUrl}RAY-Brand-Red-60.png`}
          ></img>
        </div>
      </div>
    );
  }
};

const Header = ({ t, store }) => {
  return (
    <div className="header row">
      <div className="logo col-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          space="preserve"
          version="1.1"
          viewBox="0 0 3300 3300"
          xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <style type="text/css"></style>
            <clipPath id="id0">
              <path d="M196 959l2761 0 0 1205 -2761 0 0 -1205z" />
            </clipPath>
            <clipPath id="id1">
              <path d="M228 959l2729 0 0 1182 -2729 0 0 -1182z" />
            </clipPath>
            <clipPath id="id2">
              <path d="M196 959l2761 0 0 1205 -2761 0 0 -1205z" />
            </clipPath>
            <clipPath id="logo-mask">
              <path
                className="fil3"
                d="M1600 187c980,-2 1527,594 1603,1421 0,778 -638,1439 -1721,1439 -542,0 -1409,-341 -1409,-897l0 -762 0 -1203c0,0 1209,3 1527,2z"
              />
            </clipPath>
            <linearGradient
              id="id3"
              gradientUnits="userSpaceOnUse"
              x1="10.9"
              y1="1430.18"
              x2="8783.2"
              y2="1430.18"
            >
              <stop
                offset="0"
                style={{ stopOpacity: 1, stopColor: "#CBB9AA" }}
              />
              <stop
                offset="0.419608"
                style={{ stopOpacity: 1, stopColor: "#E5DCD4" }}
              />
              <stop offset="1" style={{ stopOpacity: 1, stopColor: "white" }} />
            </linearGradient>
            <linearGradient
              id="id4"
              gradientUnits="userSpaceOnUse"
              x1="3189.07"
              y1="1417.21"
              x2="13.83"
              y2="1814.85"
            >
              <stop
                offset="0"
                style={{ stopOpacity: 1, stopColor: "#CCB9AA" }}
              />
              <stop
                offset="1"
                style={{ stopOpacity: 1, stopColor: "#A08F7D" }}
              />
            </linearGradient>
          </defs>
          <g id="Capa_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer" />

            <g style={{ clipPath: "url(#logo-mask)" }}>
              <g></g>
              <g style={{ clipPath: "url(#logo-mask)" }}>
                <rect
                  style={{ fill: "#ffffff" }}
                  id="rect862"
                  width="3303"
                  height="3303"
                  x="20"
                  y="156"
                />

                <image
                  x="0"
                  y="0"
                  width="3303"
                  height="3303"
                  href={store.logo}
                />
              </g>
              <g style={{ clipPath: "url(#id2)" }}></g>
            </g>
            <path
              className="fil4"
              d="M1372 3021c-292,-24 -537,-98 -796,-239 -140,-82 -245,-161 -347,-291 -91,-125 -141,-231 -145,-389 -1,-282 -2,-289 -3,-571 -2,-442 3,-884 2,-1326 0,-3 0,4 -1,6 -1,2 -3,4 -4,6 -1,1 -3,2 -5,3 -1,1 -5,2 -6,2 -5,-1 1035,-1 1515,-4 -505,-6 -1010,-4 -1515,-12 0,0 0,0 0,0 1,0 1,0 1,0 0,0 0,-1 0,-1 0,0 0,0 0,0 0,0 -11,816 -12,1030 -2,-344 3,-687 2,-1030 0,-2 0,-3 0,-4 1,-1 2,-2 2,-3 1,-1 3,-2 3,-2 1,-1 4,-1 4,-1 1,-1 468,-2 498,-2 -166,-1 -333,-2 -498,-5 -3,0 -4,1 -6,1 -2,1 -4,3 -6,4 -1,1 -2,4 -3,5 -1,1 -1,7 -1,7 -1,0 -12,896 -13,971 -4,-323 -2,-648 -4,-971 0,-5 1,-9 3,-14 1,-4 5,-7 7,-10 2,-4 7,-6 10,-8 3,-1 13,-2 13,-2 4,-4 1289,-14 1411,-15 -470,1 -941,-1 -1411,2 -7,0 -12,1 -18,4 -5,2 -9,5 -14,10 -4,4 -7,9 -9,15 -3,3 -4,13 -4,18 0,187 -6,374 -5,561 -3,-187 0,-374 -1,-561 0,-8 1,-14 4,-21 2,-7 6,-12 11,-17 5,-5 9,-8 16,-11 7,-3 12,-5 20,-5 6,-5 1371,-18 1516,-22 -505,5 -1011,1 -1516,7 -10,0 -17,2 -26,5 -8,4 -14,9 -21,15 -6,7 -10,13 -14,22 -4,5 -5,20 -5,27 2,442 -3,884 0,1326 1,282 0,289 4,571 3,177 60,298 163,438 110,139 221,224 371,312 211,115 399,180 633,224 101,17 191,26 293,27 271,-4 481,-35 737,-127 220,-86 376,-179 551,-342 429,-427 556,-896 360,-1483 -76,-205 -159,-349 -304,-510 -159,-164 -302,-257 -510,-343 -248,-93 -453,-121 -716,-123 260,1 467,37 714,129 205,87 347,181 503,345 143,161 224,304 297,508 71,215 84,392 86,618 1,5 0,23 -1,29 1,-6 1,-25 1,-29 -3,-226 -19,-402 -92,-616 -74,-202 -156,-343 -300,-501 -103,-107 -196,-178 -324,-252 126,72 218,149 321,256 141,158 220,300 293,501 66,201 79,366 84,578 -8,-211 -24,-375 -93,-574 -75,-198 -157,-337 -299,-491 -154,-156 -293,-244 -494,-325 -188,-69 -345,-97 -543,-109 197,12 354,45 541,114 199,82 337,171 489,328 139,154 219,291 291,488 20,56 35,110 49,168 -14,-58 -31,-111 -51,-167 -74,-196 -155,-331 -296,-483 -152,-153 -289,-239 -487,-318 -239,-86 -437,-110 -689,-109 249,-1 448,32 685,118 196,80 330,167 480,321 136,151 214,286 286,479 184,546 63,992 -336,1391 -166,155 -314,245 -523,327 -246,89 -449,120 -710,124 -31,0 -62,0 -93,-2z"
            />
            <g></g>

            <polygon
              className="fil5"
              points="196,959 2957,959 2957,2164 196,2164 "
            />
          </g>
        </svg>
      </div>
      <div className="col-9 m-auto">
        <p className="title h4 mt-0 d-block d-md-none text-right">
          {t("thanks")}
        </p>
        <p className="title h2 mt-0 d-none d-md-block">{t("thanks")}</p>
      </div>
    </div>
  );
};

const Content = ({ store, t, setShowReviewForm }) => {
  return (
    <div class="main-content mx-2 mx-md-auto">
      <p class="content">{t("text1")}</p>
      {store.googleBusinessURL && (
        <div className="review-btn">
          <MDBBtn
            onClick={() => {
              window.open(store.googleBusinessURL);
            }}
            color="custom"
            className="google-btn review-btn"
          >
            <img
              className={"mr-1"}
              src={envConfig.staticImgUrl + "social_logos/Google.png"}
              alt="google-icon"
            />{" "}
            {t("googleBtn")}
          </MDBBtn>
        </div>
      )}
      {store.facebookURL && (
        <div className="review-btn">
          <MDBBtn
            onClick={() => {
              window.open(store.facebookURL, "_blank");
            }}
            color="custom"
            className="review-btn"
          >
            <img
              className={"mr-1"}
              src={envConfig.staticImgUrl + "social_logos/Facebook.png"}
              alt="facebook-icon"
            />{" "}
            {t("facebookBtn")}
          </MDBBtn>
        </div>
      )}
      <div className="bold background-gray">{t("badExperience")}</div>
      <p class="content">{t("text2")}</p>
      <div className="review-btn">
        <MDBBtn
          type="submit"
          color="custom"
          className="review-btn text-center"
          onClick={() => setShowReviewForm(true)}
        >
          <img
            className={"mr-1"}
            src={envConfig.staticImgUrl + "social_logos/Directo.png"}
            alt="direct-icon"
          />
          {t("internBtn")}
        </MDBBtn>
      </div>
    </div>
  );
};

GiveNps.translations = { ...translations };

export default translate(GiveNps);
